import getIframeDocument from '@newswebsiteapp/shared/lib/getIframeDocument'

import { newsletterIframeLoadedObservable } from './observables'

newsletterIframeLoadedObservable.subscribe((iframe) => {
  const { body } = getIframeDocument(iframe)
  const body$ = $(body)

  body$.find('a').attr('target', '_blank')
  // body$.find('a').attr('onclick', "window.open(this.href, '_blank'); return false;")
})
